<script lang="ts" setup></script>

<template>
  <div class="flex items-center justify-center h-screen">
    <div class="text-center">
      <h1>404 Not found</h1>
      <p>페이지를 찾을 수 없다(작업중)</p>
      <RouterLink to="/">
        <button class="btn">홈으로 이동</button>
      </RouterLink>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  h1 {
    color: rebeccapurple;
  }
</style>
